export const handleInput = (
    setModif: any,
    value: string | number | Date | null | undefined
) => {
    setModif(
        value
    )
}
export const handleInputChange = (
    fieldName: string,
    setModif: any,
    user: any,
    value: string | number | Date | null | undefined
) => {
    if (!user) {
        console.error('User is undefined');
        return;
    }

    setModif((prevConf: any) => ({
        ...prevConf,
        user: {
            ...user,
            [fieldName]: value ?? user[fieldName]
        }
    }))
}
export const handleInputChangePrestaMateriel = (id: string, setModif: any, name: string, value: any) => {
    setModif((prevDetails: any) => updateNestedCategoryMateriel(prevDetails, id, name, value));
};
const updateNestedCategoryMateriel = (categories: any, id: string, name: string, value: any): any => {
    return categories.map((category: any) => {
        if (category?.rpl_id === id) {
            const updatedCategory = { ...category };
            const qteLivree = updatedCategory.rpl_qte_liv;
            const validValue = Math.max(0, Math.min(value, qteLivree));
            if (name === "rpl_laisse_sur_place") {
                updatedCategory.rpl_laisse_sur_place = !updatedCategory.rpl_laisse_sur_place
            }
            if (name === "rpl_laisse_sur_place_note") {
                updatedCategory.rpl_laisse_sur_place_note = value
            }
            if (name === "rpl_facturer_heure_suppl") {
                updatedCategory.rpl_facturer_heure_suppl = !value
            }
            if (name === 'rpl_qte_ret') {
                updatedCategory[name] = validValue
                updatedCategory.rpl_qte_fact_uf = qteLivree - validValue; // Facture = livrée - retour
                updatedCategory.rpl_qte_casse_ukc = qteLivree - validValue; // Casse = livrée - retour
            } else if (name === 'rpl_qte_fact_uf') {
                updatedCategory[name] = validValue;
                updatedCategory.rpl_qte_ret = qteLivree - validValue; // Retour = livrée - facture
                updatedCategory.rpl_qte_casse_ukc = validValue; // Casse = facture
            } else if (name === 'rpl_qte_casse_ukc') {
                updatedCategory[name] = validValue;
                updatedCategory.rpl_qte_fact_uf = validValue; // Facture = casse
                updatedCategory.rpl_qte_ret = qteLivree - validValue; // Retour = livrée - casse
            }
            return updatedCategory;
        } else if (category?.sous_categorie && category?.sous_categorie.length > 0) {
            return {
                ...category,
                sous_categorie: updateNestedCategoryMateriel(category.sous_categorie, id, name, value),
            };
        } else {
            return category;
        }
    });
};
export const handleInputChangePrestaConsommation = (id: string, setModif: any, name: string, value: any) => {
    setModif((prevDetails: any) => updateNestedCategoryConsomation(prevDetails, id, name, value));
};
const updateNestedCategoryConsomation = (categories: any, id: string, name: string, value: any): any => {
    return categories.map((category: any) => {
        if (id !== null && category?.rpl_id === id) {
            const updatedCategory = { ...category };
            const qteLivree = updatedCategory.rpl_qte_liv;
            const validValue = Math.max(0, Math.min(value, qteLivree));
            updatedCategory[name] = validValue;
            if (name === 'rpl_qte_ret') {
                updatedCategory.rpl_qte_fact_uf = qteLivree - validValue; // Facture = livrée - retour
                updatedCategory.rpl_qte_casse_ukc = qteLivree - validValue; // Casse = livrée - retour
            } else if (name === 'rpl_qte_fact_uf') {
                updatedCategory.rpl_qte_ret = qteLivree - validValue; // Retour = livrée - facture
                updatedCategory.rpl_qte_casse_ukc = validValue; // Casse = facture
            } else if (name === 'rpl_qte_casse_ukc') {
                updatedCategory.rpl_qte_fact_uf = validValue; // Facture = casse
                updatedCategory.rpl_qte_ret = qteLivree - validValue; // Retour = livrée - casse
            }
            return updatedCategory;
        } else if (id !== null && category?.sous_categorie && category?.sous_categorie.length > 0) {
            return {
                ...category,
                sous_categorie: updateNestedCategoryConsomation(category.sous_categorie, id, name, value),
            };
        } else {
            return category;
        }
    });
};

interface DataSendPerso {
    rpl_heure_reelle_depart_site: string;
    rpl_heure_consommee_en_plus: string;
    v_heure_prevue_depart_site: string;
}

// Fonction pour calculer la différence d'heures entre deux valeurs HH:mm
export const handleTimeChangePresta = (key: string, value: string, setModif: any, id: string, showError: any) => {
    const formattedValue = formatTimeInput(value);

    // Passer la valeur formatée pour la mise à jour
    setModif((prevDetails: any) => updateNestedCategoryTime(prevDetails, id, key, formattedValue, showError));
    setModif((prevDetails: any) => updateNestedCategoryTime(prevDetails, id, key, value, showError));
};
const formatTimeInput = (time: string): string => {
    if (!time) return "00:00";

    const [hours, minutes] = time.split(":"); // Ignore les secondes s'il y en a
    return `${hours}:${minutes}`; // Retourne HH:mm proprement
};
// Fonction récursive pour traiter les catégories et sous-catégories
const updateNestedCategoryTime = (
    categories: any,
    id: string,
    key: string,
    value: string,
    showError: any
): any => {
    return categories.map((category: any) => {
        if (category.rpl_id === id) {
            const updatedCategory = { ...category };
            updatedCategory[key] = value;

            const heurePrevue = updatedCategory.v_heure_prevue_depart_site;
            const heureReelle = updatedCategory.rpl_heure_reelle_depart_site;

            // Calcul si les deux heures sont définies
            if (heurePrevue && heureReelle) {
                const diff = calculateTimeDifference(heurePrevue, heureReelle, showError);

                if (diff === 0 && heurePrevue !== heureReelle) {
                    // Erreur détectée : on remet l'heure réelle = prévue
                    updatedCategory.rpl_heure_reelle_depart_site = heurePrevue;
                    updatedCategory.rpl_heure_consommee_en_plus = 0;
                } else {
                    updatedCategory.rpl_heure_consommee_en_plus = diff;
                }
            }

            return updatedCategory;
        }

        // 🔁 Recherche récursive dans les sous-catégories
        if (category.sous_categorie && category.sous_categorie.length > 0) {
            return {
                ...category,
                sous_categorie: updateNestedCategoryTime(category.sous_categorie, id, key, value, showError),
            };
        }

        return category;
    });
};

// Fonction pour calculer la différence d'heures entre deux valeurs HH:mm
const calculateTimeDifference = (start: string, end: string, showError: any): number => {

    const [startHours, startMinutes] = start.split(":").map(Number);
    const [endHours, endMinutes] = end.split(":").map(Number);

    const startDate = new Date();
    startDate.setHours(startHours, startMinutes, 0, 0);

    const endDate = new Date();
    endDate.setHours(endHours, endMinutes, 0, 0);

    // Si fin < début, on suppose que c'est le lendemain
    const isNextDay = endDate.getTime() < startDate.getTime();
    if (isNextDay) {
        endDate.setDate(endDate.getDate() + 1);
    }

    const diffMs = endDate.getTime() - startDate.getTime();
    const diffMinutes = Math.floor(diffMs / 60000);
    const diffDecimalHours = diffMinutes / 60;

    // ✅ Bloquer si > 12h
    if (diffDecimalHours > 12) {
        showError("L'heure réelle de départ dépasse la limite de 12 heures après l'heure prévue.")
        return 0;
    }


    return parseFloat(diffDecimalHours.toFixed(2));
};



export const convertDecimalToTime = (decimalHours: number): string => {
    if (!decimalHours || isNaN(decimalHours)) return "00:00";

    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};
